import { Button } from '@mui/material';
import { useLanguage } from '../../../contexts/language';
import { InvoiceStatus } from '../../../types/invoices';
import { useState } from 'react';
import ConfirmationDialog, {
  ConsequencesList,
} from '../../../components/ConfirmationDialog';

export interface InvoiceTemplateActionsProps {
  isLoading: boolean;
  isOperator: boolean;
  invoiceStatus: InvoiceStatus | null;
  onSubmitNewInvoiceRequest: () => void;
  isSubmitEnabled: boolean;
  onRejectRequest: () => void;
  onApproveRequest: () => void;
}

const InvoiceTemplateActions = ({
  isLoading,
  isOperator,
  invoiceStatus,
  isSubmitEnabled,
  onSubmitNewInvoiceRequest,
  onApproveRequest,
  onRejectRequest,
}: InvoiceTemplateActionsProps) => {
  const { t } = useLanguage();
  const [isConfirmingApproval, setIsConfirmingApproval] = useState(false);

  if (!invoiceStatus) {
    return (
      <Button
        type="button"
        variant="contained"
        onClick={onSubmitNewInvoiceRequest}
        disabled={!isSubmitEnabled || isLoading}
      >
        {t('content.submit-for-validation')}
      </Button>
    );
  } else if (!isOperator && invoiceStatus === InvoiceStatus.PendingApproval) {
    return (
      <>
        <div className="flex gap-4">
          <Button
            type="button"
            variant="outlined"
            color="error"
            onClick={onRejectRequest}
            disabled={isLoading}
          >
            {t('content.reject')}
          </Button>
          <Button
            type="button"
            variant="outlined"
            onClick={() => {
              setIsConfirmingApproval(true);
            }}
            loading={isLoading}
            disabled={isLoading}
          >
            {t('content.approve')}
          </Button>
        </div>
        <ConfirmationDialog
          open={Boolean(isConfirmingApproval)}
          onConfirm={() => {
            setIsConfirmingApproval(false);
            onApproveRequest();
          }}
          onClose={() => setIsConfirmingApproval(false)}
          title={t('content.invoice-approval-confirmation.title')}
        >
          <ConsequencesList
            action={t('content.invoice-approval-confirmation.action')}
            list={[
              t(
                'content.invoice-approval-confirmation.bullet-points.ensure-annual-accounts-are-sent',
              ),
            ]}
          />
        </ConfirmationDialog>
      </>
    );
  }
  return null;
};

export default InvoiceTemplateActions;
